import type { PiniaPluginContext } from 'pinia'
import type { LogExceptionFunction } from '@shared/plugins/log-exception'

/**
 * Adds the $logException function to all stores.
 */
export const piniaPluginLogException = (context: PiniaPluginContext) => {
  const { $logException = null } = { ...context.app.config.globalProperties }

  context.store.$logException = $logException as LogExceptionFunction

  if (!$logException) {
    throw new Error(
      'logException plugin not found. Ensure the logException app plugin has been installed before using any pinia stores.'
    )
  } else if (typeof $logException === 'function') {
    return { $logException }
  }
}
